import {
  OfferPricingBasis,
  PricingBasis,
} from '../../../shared/types';

function transformPricingBasis(
  pricingBasis: PricingBasis,
): OfferPricingBasis {
  return pricingBasis === 'BOTH' ? 'MONTH' : pricingBasis;
}

export default transformPricingBasis;
